import React from 'react'
import { TextInput, Label } from '@hospitalrun/components'
import classes from '../../style.module.scss'

interface Props {
  value: string
  label: string
  name: string
  isEditable?: boolean
  type: 'text' | 'email' | 'number' | 'tel' | 'password'
  placeholder?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  isRequired?: boolean
  feedback?: string
  isInvalid?: boolean
}

const TextInputWithLabelFormGroup = (props: Props) => {
  const {
    value,
    label,
    name,
    isEditable,
    onChange,
    placeholder,
    type,
    isRequired,
    feedback,
    isInvalid,
  } = props
  const id = `${name}TextInput`
  return (
    <div>
      <Label
        className={classes.label}
        text={label}
        htmlFor={id}
        isRequired={isRequired && isEditable}
      />
      {isEditable ? (
        <TextInput
          className={`${classes.input_wrapper} ${isInvalid ? 'text-danger' : undefined}`}
          feedback={feedback}
          id={id}
          isInvalid={isInvalid}
          value={value}
          disabled={!isEditable}
          onChange={onChange}
          type={type}
          placeholder={placeholder || label}
        />
      ) : (
        <div>
          <pre className="text-secondary">{value}</pre>
        </div>
      )}
    </div>
  )
}

TextInputWithLabelFormGroup.defaultProps = {
  value: '',
  type: 'text',
}

export default TextInputWithLabelFormGroup
